import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';
import colors from '../styles/colors';
import whatsappIcon from '../assets/icons/whatsapp.png';
import instagramIcon from '../assets/icons/instagram.png';

const FloatingContainer = styled.div`
  position: fixed;
  right: 20px;
  bottom: 20px;
  z-index: 1000;
  display: flex;
  flex-direction: column;
  gap: 15px;

  @media (max-width: 768px) {
    right: 15px;
    bottom: 15px;
    gap: 12px;
  }
`;

const FloatingButton = styled(motion.a)`
  display: flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  transition: all 0.3s ease;
  position: relative;
  background: transparent;
  border: none;

  &:hover {
    transform: scale(1.1);
  }
`;

const WhatsAppButton = styled(FloatingButton)``;

const InstagramButton = styled(FloatingButton)``;

const WhatsAppIcon = styled.div`
  width: 55px;
  height: 55px;
  z-index: 1;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }

  @media (max-width: 768px) {
    width: 50px;
    height: 50px;
  }
`;

const InstagramIconContainer = styled.div`
  width: 50px;
  height: 50px;
  z-index: 1;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }

  @media (max-width: 768px) {
    width: 45px;
    height: 45px;
  }
`;

const Tooltip = styled(motion.div)`
  position: absolute;
  right: 70px;
  top: 50%;
  transform: translateY(-50%);
  background: ${colors.text.primary};
  color: white;
  padding: 8px 12px;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  white-space: nowrap;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
  opacity: 0;
  pointer-events: none;

  &::after {
    content: '';
    position: absolute;
    right: -5px;
    top: 50%;
    transform: translateY(-50%);
    width: 0;
    height: 0;
    border-left: 5px solid ${colors.text.primary};
    border-top: 5px solid transparent;
    border-bottom: 5px solid transparent;
  }

  @media (max-width: 768px) {
    right: 65px;
    font-size: 13px;
    padding: 6px 10px;
  }
`;

const FloatingButtons = () => {
  const whatsappNumber = "393331054944";
  const instagramHandle = "cuorebrasiliano";

  return (
    <FloatingContainer>
      <motion.div
        initial={{ opacity: 0, x: 100 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ delay: 1, duration: 0.5 }}
      >
        <WhatsAppButton
          href={`https://wa.me/${whatsappNumber}`}
          target="_blank"
          rel="noopener noreferrer"
          whileHover={{ scale: 1.1 }}
          whileTap={{ scale: 0.95 }}
        >
          <WhatsAppIcon>
            <img src={whatsappIcon} alt="WhatsApp" />
          </WhatsAppIcon>
          <Tooltip
            initial={{ opacity: 0, x: 10 }}
            whileHover={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.2 }}
          >
            WhatsApp
          </Tooltip>
        </WhatsAppButton>
      </motion.div>

      <motion.div
        initial={{ opacity: 0, x: 100 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ delay: 1.2, duration: 0.5 }}
      >
        <InstagramButton
          href={`https://instagram.com/${instagramHandle}`}
          target="_blank"
          rel="noopener noreferrer"
          whileHover={{ scale: 1.1 }}
          whileTap={{ scale: 0.95 }}
        >
          <InstagramIconContainer>
            <img src={instagramIcon} alt="Instagram" />
          </InstagramIconContainer>
          <Tooltip
            initial={{ opacity: 0, x: 10 }}
            whileHover={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.2 }}
          >
            Instagram
          </Tooltip>
        </InstagramButton>
      </motion.div>
    </FloatingContainer>
  );
};

export default FloatingButtons;
